import React, { useState } from "react";
import { useSubheader } from "../../_metronic/layout";
import { titleCase } from "../../_metronic/_helpers";
import { useSelector, connect } from "react-redux";
import { update } from "../modules/Auth/_redux/authCrud";
import { injectIntl } from "react-intl";
import { QuickToast } from "../modules/Components/Toast"
import * as auth from "../modules/Auth/_redux/authRedux";

function Profile(props) {
  const suhbeader = useSubheader();
  suhbeader.setTitle("Profile");
  const { user } = useSelector(state => state.auth);

  const current = user.uid ? user : user.payload
  const [show, setShow] = useState(false)
  const [image, setImage] = useState(current.image_url)
  const [[toastTittle, toastMessage], setToast] = useState(["", ""])

  function onUpdate({ target }) {
    const { name, value } = target
    current[name] = value
  }
  function updateProfile(payload) {
    update(payload).then(() => {
      setShow(true)
      setToast(["Success", "Profile was updated successfully"])
      props.update(payload)
    }).catch((err) => {
      console.log(err)
      setShow(true)
      setToast(["Error", "Profile cant be updated"])

    })
  }
  function resizedataURL(datas, wantedWidth, wantedHeight) {
    return new Promise(async function (resolve, reject) {

      // We create an image to receive the Data URI
      var img = document.createElement('img');

      // When the event "onload" is triggered we can resize the image.
      img.onload = function () {
        // We create a canvas and get its context.
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');

        // We set the dimensions at the wanted size.
        canvas.width = wantedWidth;
        canvas.height = wantedHeight;

        // We resize the image with the canvas method drawImage();
        ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);

        const dataURI = canvas.toDataURL();

        // This is the return of the Promise
        resolve(dataURI);
      };

      // We put the Data URI in the image's src attribute
      img.src = datas;

    })
  }
  function updatePhoto({ target }) {
    const [file] = target.files;
    const reader = new FileReader();
    reader.addEventListener(
      "load",
      ({ target }) => {
        resizedataURL(target.result, 100, 100)
          .then((data) => {
            setImage(data)
            current["image_url"] = data
          })

      },
      false
    );
    if (file) {
      reader.readAsDataURL(file);
    }
  }

  return (
    <>
      <QuickToast
        title={toastTittle}
        message={toastMessage}
        show={show}
        setShow={setShow}
      />
      <div>
        <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
          <div className="d-flex flex-column-fluid">
            <div className="container">
              <div className="d-flex flex-row">
                <div className="flex-row-auto offcanvas-mobile w-250px w-xxl-350px" id="kt_profile_aside" >
                  <div className="card card-custom card-stretch">
                    <div className="card-body pt-4">
                      <div className="d-flex justify-content-end">
                        <div className="dropdown dropdown-inline" style={{ color: "white" }}>
                          .
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center">
                          <div className="symbol-label" style={{
                            backgroundImage: `url(${current.image_url})`
                          }}></div>
                          <i className="symbol-badge bg-success"></i>
                        </div>
                        <div>
                          <a href="/user/profile" className="font-weight-bolder font-size-h5 text-dark-75 text-hover-primary">
                            {titleCase(`${current.name} ${current.last_name}`)}
                          </a>
                          <div className="text-muted">Administrator</div>
                          <div className="mt-2">
                            {/* <a href="." className="btn btn-sm btn-primary font-weight-bold mr-2 py-2 px-3 px-xxl-5 my-1">Chat</a>
                            <a href="." className="btn btn-sm btn-success font-weight-bold py-2 px-3 px-xxl-5 my-1">Follow</a> */}
                          </div>
                        </div>
                      </div>
                      <div className="py-9">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <span className="font-weight-bold mr-2">Email:</span>
                          <a href="/user/profile" className="text-muted text-hover-primary truncate">{current.email}</a>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <span className="font-weight-bold mr-2">Phone:</span>
                          <span className="text-muted">{current.phone || <span className="text-danger">missing</span>}</span>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                          <span className="font-weight-bold mr-2">Location:</span>
                          <span className="text-muted">{current.country || <span className="text-danger">missing</span>}</span>
                        </div>
                      </div>
                      <div className="navi navi-bold navi-hover navi-active navi-link-rounded">

                        <div className="navi-item mb-2">
                          <a href="/user/profile" className="navi-link py-4 active">
                            <span className="navi-icon mr-2">
                              <span className="svg-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                  <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <polygon points="0 0 24 0 24 24 0 24" />
                                    <path d="M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z" fill="#000000" fillRule="nonzero" opacity="0.3" />
                                    <path d="M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z" fill="#000000" fillRule="nonzero" />
                                  </g>
                                </svg>
                              </span>
                            </span>
                            <span className="navi-text font-size-lg">Personal Information</span>
                          </a>
                        </div>

                        <div className="navi-item mb-2">
                          <a href="/user/reset-password" className="navi-link py-4">
                            <span className="navi-icon mr-2">
                              <span className="svg-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                  <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <rect x="0" y="0" width="24" height="24" />
                                    <path d="M4,4 L11.6314229,2.5691082 C11.8750185,2.52343403 12.1249815,2.52343403 12.3685771,2.5691082 L20,4 L20,13.2830094 C20,16.2173861 18.4883464,18.9447835 16,20.5 L12.5299989,22.6687507 C12.2057287,22.8714196 11.7942713,22.8714196 11.4700011,22.6687507 L8,20.5 C5.51165358,18.9447835 4,16.2173861 4,13.2830094 L4,4 Z" fill="#000000" opacity="0.3" />
                                    <path d="M12,11 C10.8954305,11 10,10.1045695 10,9 C10,7.8954305 10.8954305,7 12,7 C13.1045695,7 14,7.8954305 14,9 C14,10.1045695 13.1045695,11 12,11 Z" fill="#000000" opacity="0.3" />
                                    <path d="M7.00036205,16.4995035 C7.21569918,13.5165724 9.36772908,12 11.9907452,12 C14.6506758,12 16.8360465,13.4332455 16.9988413,16.5 C17.0053266,16.6221713 16.9988413,17 16.5815,17 C14.5228466,17 11.463736,17 7.4041679,17 C7.26484009,17 6.98863236,16.6619875 7.00036205,16.4995035 Z" fill="#000000" opacity="0.3" />
                                  </g>
                                </svg>
                              </span>
                            </span>
                            <span className="navi-text font-size-lg">Change Password</span>
                            {/* <span className="navi-label">
                              <span className="label label-light-danger label-rounded font-weight-bold">5</span>
                            </span> */}
                          </a>
                        </div>

                      </div >
                    </div >
                  </div >
                </div >
                <div className="flex-row-fluid ml-lg-8">
                  <div className="card card-custom card-stretch">
                    <div className="card-header py-3">
                      <div className="card-title align-items-start flex-column">
                        <h3 className="card-label font-weight-bolder text-dark">Personal Information</h3>
                        <span className="text-muted font-weight-bold font-size-sm mt-1">Update your personal informaiton</span>
                      </div>
                      <div className="card-toolbar">
                        <button type="reset" className="btn btn-success mr-2" onClick={() => updateProfile(current)}>Save Changes</button>
                        <a href="/dashboard" type="reset" className="btn btn-secondary">Cancel</a>
                      </div>
                    </div>
                    <div className="form">
                      <div className="card-body">
                        <div className="row">
                          <label className="col-xl-3"></label>
                          <div className="col-lg-9 col-xl-6">
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-xl-3 col-lg-3 col-form-label">Avatar</label>
                          <div className="col-lg-9 col-xl-6">
                            <div className="image-input image-input-outline" id="kt_profile_avatar" >
                              <div className="image-input-wrapper" style={{
                                backgroundImage: `url(${image})`
                              }}></div>
                              <label className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow" data-action="change" data-toggle="tooltip" title="" data-original-title="Change avatar">
                                <i className="fa fa-pen icon-sm text-muted"></i>
                                <input type="file" name="profile_avatar" accept=".png, .jpg, .jpeg" onChange={updatePhoto} />
                                <input type="hidden" name="profile_avatar_remove" />
                              </label>
                              <span className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow" data-action="cancel" data-toggle="tooltip" title="Cancel avatar">
                                <i className="ki ki-bold-close icon-xs text-muted"></i>
                              </span>

                            </div>
                            <span className="form-text text-muted">Allowed file types: png, jpg, jpeg.</span>
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-xl-3 col-lg-3 col-form-label">First Name</label>
                          <div className="col-lg-9 col-xl-6">
                            <input className="form-control form-control-lg form-control-solid" type="text" defaultValue={current.name} name="name" onChange={onUpdate} />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-xl-3 col-lg-3 col-form-label">Last Name</label>
                          <div className="col-lg-9 col-xl-6">
                            <input className="form-control form-control-lg form-control-solid" type="text" defaultValue={current.last_name} name="last_name" onChange={onUpdate} />
                          </div>
                        </div>

                        <div className="row">
                          <label className="col-xl-3"></label>
                          <div className="col-lg-9 col-xl-6">
                            <h5 className="font-weight-bold mt-10 mb-6">Contact Info</h5>
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-xl-3 col-lg-3 col-form-label">Contact Phone</label>
                          <div className="col-lg-9 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">

                              <input type="text" className="form-control form-control-lg form-control-solid" defaultValue={current.phone} placeholder="Phone" name="phone" onChange={onUpdate} />
                            </div>
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-xl-3 col-lg-3 col-form-label">Email Address</label>
                          <div className="col-lg-9 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">

                              <input type="text" className="form-control form-control-lg form-control-solid" defaultValue={current.email} placeholder="Email" disabled name="email" onChange={onUpdate} />
                            </div>
                            <span className="form-text text-muted">We'll never share your email with anyone else.</span>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div >
            </div >
          </div >
        </div >
      </div >


    </>
  );
};
export default injectIntl(connect(null, auth.actions)(Profile));